import React from "react";
import { Divider } from "antd";
import OrderHistory from "../components/OrderHistory/OrderHistory";
import EmptyOrderHistory from "../components/OrderHistory/EmptyOrderHistory";
import { t } from "i18next";
const OrderHistoryPage = () => {
  const storedTickets = localStorage.getItem("createdTickets");
  let createdTickets = [];

  if (storedTickets) {
    try {
      createdTickets = JSON.parse(storedTickets);
    } catch (error) {}
  }

  return (
    <div className="order-history-page-container">
      <div className="order-history-form-container">
        <div>
          <div className="order-history-form-items-container">
            <h1 className="order-history-heading">{t("orderHistory")}</h1>
          </div>
          <p className="order-history-description">
            {t("lastOrderHistory")} <b>10</b> {t("previuseTicketHistory")}
          </p>
          <Divider />
          {createdTickets.length > 0 ? <OrderHistory /> : <EmptyOrderHistory />}
        </div>
      </div>
      <div className="order-history-column-image"></div>
    </div>
  );
};

export default OrderHistoryPage;
